import { BlastModelType } from 'app/business-logic/domain-models/Blasting';

const createNew = (root: string) => {
  const createRoot = `${root}/create` as const;
  return {
    root: createRoot,
    [BlastModelType.Flyrock]: `${createRoot}/${BlastModelType.Flyrock}`,
    [`${BlastModelType.Dispersion}|${BlastModelType.FumeManagementZone}`]: `${createRoot}/${BlastModelType.Dispersion}-${BlastModelType.FumeManagementZone}`,
    [BlastModelType.GroundVibration]: `${createRoot}/${BlastModelType.GroundVibration}`,
    [`${BlastModelType.OverpressureContour}|${BlastModelType.OverpressureGain}`]: `${createRoot}/${BlastModelType.OverpressureContour}-${BlastModelType.OverpressureGain}`,
    [BlastModelType.Path]: `${createRoot}/${BlastModelType.Path}`,
    [BlastModelType.Vibration]: `${createRoot}/${BlastModelType.Vibration}`,
  } as const;
};

const viewScenario = (root: string) => () => {
  return `${root}/view/:alias`;
};

export const blastingRoutes = (root: string) => ({
  root,
  createNew: createNew(root),
  viewScenario: viewScenario(root),
});
